declare namespace $ {

	export class $giper_baza_land_grab extends $mol_select {
		Trigger_icon( ): $mol_icon_plus
		Filter( ): any
		trigger_content( ): readonly(any)[]
		dictionary( ): ({ 
			'pull': string,
			'post': string,
			'read': string,
			'deny': string,
		}) 
		grab( next?: $giper_baza_rank_preset | null ): $giper_baza_rank_preset | null
	}
	
}

//# sourceMappingURL=grab.view.tree.d.ts.map